import React from 'react';
import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import { getBlockReleasesByUnit as getBlockReleasesAction } from '@data/blockReleases/actionCreators/BlockReleaseActionCreators';
import {
	BlockReleaseApiResponse,
} from '@data/blockReleases/types/BlockRelease.types';
import { doesUnitHaveOpenTime } from '@utilities/doesUnitHaveOpenTime';
import { sortBlockReleases } from '@components/BlockRelease/utils/sortBlockReleases/sortBlockReleases';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';
import usePreferredUnits from '@components/UnitCalendarPage/utilities/usePreferredUnits';
import useCollection from '@utilities/hooks/useCollection/useCollection';
import { Unit } from '@data/unit/Unit';
import { ENDPOINT_USER_UNITS } from '@utilities/apiConstants';

export const useGetBlockReleasesByUnit = () => {
	const dispatch = useDispatch();
	const [blockReleaseList, setBlockReleaseList] = React.useState<BlockReleaseApiResponse[]>([]);
	const allUnits = useCollection<Unit>(ENDPOINT_USER_UNITS);
	const preferredUnits = usePreferredUnits();


	const preferredUnitsWithOpenTime = React.useMemo(() => {
		return preferredUnits.list.reduce<string[]>((acc, unit) => {
			const fullUnitData = allUnits.find(u => u.id === unit.id);
			if (fullUnitData && doesUnitHaveOpenTime(fullUnitData)) {
				acc.push(unit.name);
			}
			return acc;
		}, []);
	}, [allUnits, preferredUnits.list]);

	const getBlockReleases = React.useCallback(
		(requestOverride?: Partial<ApiActionPayload<BlockReleaseApiResponse[]>>) => {

			if (!preferredUnitsWithOpenTime?.length) {
				return;
			}

			const onSuccess = (response: AxiosResponse<BlockReleaseApiResponse[]>) => {
				const sortedBlockReleases = sortBlockReleases(response.data);
				setBlockReleaseList(sortedBlockReleases);
			};

			dispatch(
				getBlockReleasesAction(preferredUnitsWithOpenTime, {
					onSuccess,
					...requestOverride,
				}),
			);
		},
		[dispatch, preferredUnitsWithOpenTime],
	);

	return {
		blockReleaseList,
		setBlockReleaseList,
		getBlockReleases
	};
};
